import AddToWatchlistCookie from "./addToWatchListCookie";

export default function AddToWatchlist(identifier) {
  $.ajax({
    url: "/api/CustomersWishlist/AddToWatchlist?identifier=" + identifier,
    type: "POST",
    async: true,
    statusCode: {
      401: function () {
        $.featherlight("#login-dialog"); AddToWatchlistCookie(identifier);
      }
    },
    success: function (data) {
      if (data != null) {
        if (data.status == "ok") {
          var $productEl = $(".prod_" + identifier);
          $productEl.html(data.message);
          $productEl.attr("onclick", "return false;");
          $productEl.removeClass("btn-watchlist-add")
          $productEl.addClass("btn-watchlist-added");
        }
      }
    }
  });
}